import styled, {css} from 'styled-components';

import {sizes} from '../../_old/styled/theme';
import {scToTwColour} from '../../theme';

const Content = styled.div`
  width: 100%;
  padding: 1rem;
  background-color: ${scToTwColour('theme.colors.slate1')};

  // hamburger
  @media (min-width: ${sizes.lg}px) and (hover: hover) {
    & {
      padding: 2rem;
    }
  }
`;

const Main = styled.main<{$isFullwidth?: boolean}>`
  position: relative;
  flex: 1 1 auto;
  max-width: 100%;

  ${({$isFullwidth}) =>
    $isFullwidth &&
    css`
      height: 100%;
      flex: 1 1 100%;
    `}

  padding: ${({$isFullwidth}) => ($isFullwidth ? '0' : '1.25rem 0.6rem')};
  ${Content} {
    padding: ${({$isFullwidth}) => ($isFullwidth ? '2.25rem 1.6rem' : 'inherit')};
  }

  ${({theme, $isFullwidth}) => theme.media.sm`
    padding: ${$isFullwidth ? '0' : '1.25rem'};

    ${Content} {
      padding: ${$isFullwidth ? '2.25rem' : 'inherit'};
    }
  `}

  ${({theme, $isFullwidth}) => theme.media.lg`
    padding: ${$isFullwidth ? '0' : '2.5rem'};

    ${Content} {
      padding: ${$isFullwidth ? '3.5rem' : 'inherit'};
    }
  `}
`;

const Title = styled.div`
  margin-bottom: 1em;

  ${({theme}) => theme.media.sm`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}
`;

const Section = styled.section`
  margin-bottom: 1rem;

  ${({theme}) => theme.media.md`
    margin-bottom: 4rem;
  `}

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const PageLayout = {
  Main,
  Title,
  Content,
  Section,
};
